import { createOccoSsoAuth } from '../../../packages/src/cognito-sso/index.js';

// Cognito Hosted UI (SSO) auth for the photo-album admin surface.
// Env is initialised by js/common.js (initCognitoSsoEnv), which every page loads.
export default createOccoSsoAuth({
  redirectAfterLogin: 'admin-console.html',
  loginPath: 'index.html',
});
